import LoadingPage from "./loadingPage";

export default LoadingPage;